/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CustomRouteAliases {
  ACTION_PANEL = 'action-panel',
  CUSTOM_ROUTE_TEXT = 'custom-route-text',
  GO_TO_LOGIN_BUTTON = 'go-to-login-button',
  MAIN_LAYOUT = 'main-layout',
}
export { CustomRouteAliases };
